import NamedDto from 'modules/base/dto/NamedDto';

export class ProjectTableDto extends NamedDto {
	/**
	 * @typedef {Object} _ProjectTableDtoProps
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _ProjectTableDtoProps} ProjectTableDtoProps
	 */
	/**
	 *
	 * @param {ProjectTableDtoProps} props
	 * @returns {ProjectTableDto}
	 */
	setup(props) {
		super.setup(props);
		return this;
	}
}

export default ProjectTableDto;
